/* V3 Partnerprogramm-Rechner: Betrag = (n + round(n x Quote), wenn Schalter an) x Provision. Ohne Abhaengigkeiten. */
(function(){
  function fmt(v,sep){return String(v).replace(/\B(?=(\d{3})+(?!\d))/g,sep);}
  function init(el){
    if(el.dataset.v3afReady)return;el.dataset.v3afReady='1';
    var prov=+el.dataset.prov||15,rate=(+el.dataset.rate||0)/100,cur=el.dataset.cur||'€',sep=el.dataset.sep||'.';
    var one=el.dataset.one||'Bestellung',many=el.dataset.many||'Bestellungen';
    var r=el.querySelector('[data-r]'),t=el.querySelector('[data-t]');if(!r)return;
    var q=function(s){return el.querySelector(s);},chips=el.querySelectorAll('[data-chip]');
    var nEl=q('[data-n]'),l1=q('[data-l1]'),v1=q('[data-v1]'),l2=q('[data-l2]'),v2=q('[data-v2]'),sum=q('[data-sum]');
    var pm=(q('.v3af__sum span')||{}).textContent||'';
    var pct=Math.round(rate*100);
    function upd(){
      var n=Math.max(1,Math.round(+r.value||1)),on=!t||t.checked,re=Math.round(n*rate),tot=(n+(on?re:0))*prov;
      var min=+r.min||1,max=+r.max||500;
      r.style.setProperty('--p',((n-min)*100/Math.max(1,max-min))+'%');
      nEl.textContent=fmt(n,sep);
      l1.textContent=fmt(n,sep)+' '+(n===1?one:many)+'\u00a0×\u00a0'+prov+'\u00a0'+cur;
      v1.textContent=fmt(n*prov,sep)+' '+cur;
      l2.textContent='+ ca. '+pct+' % '+(l2.dataset.w||(l2.dataset.w=l2.textContent.replace(/^\+ ca\. \d+ % /,'').replace(/:.*$/,'')))+': '+fmt(on?re:0,sep)+'\u00a0×\u00a0'+prov+'\u00a0'+cur;
      v2.textContent='+ '+fmt(on?re*prov:0,sep)+' '+cur;
      sum.textContent=fmt(tot,sep)+' '+cur;
      el.classList.toggle('is-off',!on);
      r.setAttribute('aria-valuetext',fmt(n,sep)+' '+(n===1?one:many)+', '+fmt(tot,sep)+' '+cur+' '+pm);
      for(var i=0;i<chips.length;i++)chips[i].setAttribute('aria-pressed',+chips[i].dataset.chip===n?'true':'false');
    }
    r.addEventListener('input',upd);
    if(t)t.addEventListener('change',upd);
    for(var i=0;i<chips.length;i++)chips[i].addEventListener('click',function(){r.value=this.dataset.chip;upd();});
    upd();
  }
  function all(){var a=document.querySelectorAll('[data-v3af]');for(var i=0;i<a.length;i++)init(a[i]);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();
